import { render } from "./validation.vue?vue&type=template&id=460d09a3"
import script from "./validation.vue?vue&type=script&lang=js"
export * from "./validation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__